import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = {
  key: 1,
  class: "loadingwrapper"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted } from "vue";
import { globalStore } from "@/stores/global";
import Sidebar from "@/components/Sidebar.vue";
import NewsletterAlert from "@/components/NewsletterAlert.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  setTimeout(async () => {
    const store = globalStore();
    await store.setAuth0Token();
    store.loadStuff();
  }, 200);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$auth0.isAuthenticated.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Sidebar)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
    (_openBlock(), _createBlock(_Teleport, { to: "#alert" }, [
      _createVNode(NewsletterAlert)
    ]))
  ], 64))
}
}

})